import { Controller } from "@hotwired/stimulus";
import Flickity from "flickity";
import "flickity/dist/flickity.css";
import throttle from "lodash.throttle";

export default class extends Controller {
  initialize() {
    this.body = document.querySelector("body");
    this.flickity = null;
    this.previousSlide = null;
  }

  connect() {
    this.initFlickity();

    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      // Keep the current slide for next initFlickity call
      window.slidesCurrent = this.flickity.selectedIndex;
    }

    // Destroy the carousel before Turbo caches the page
    document.addEventListener("turbo:before-cache", this.destroyFlickity.bind(this), {
      once: true,
    });

    this.throttledOnResize = throttle(this.onResize.bind(this), 500);
    window.addEventListener("resize", this.throttledOnResize);
  }

  disconnect() {
    window.removeEventListener("resize", this.throttledOnResize);
  }

  initFlickity() {
    this.flickity = new Flickity(this.element, {
      autoPlay: 5000,
      initialIndex: this.data.get("current") || window.slidesCurrent,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      setGallerySize: false,
      wrapAround: true,
    });
    window.slidesCurrent = null;

    // fix iOS bug, see https://github.com/metafizzy/flickity/issues/740#issuecomment-442202965
    this.flickity.on("dragStart", () => {
      document.ontouchmove = (e) => e.preventDefault();
    });
    this.flickity.on("dragEnd", () => {
      document.ontouchmove = () => true;
    });

    this.flickity.on("change", this.onSlide.bind(this));

    this.setBodyModifier();
    this.flickity.on("select", this.setBodyModifier.bind(this));
  }

  destroyFlickity() {
    // Save the current index
    this.data.set("current", this.flickity.selectedIndex);

    this.flickity.destroy();
    this.flickity = null;
  }

  onResize() {
    this.flickity.resize();
  }

  onSlide() {
    const event = new CustomEvent("reveal");
    this.flickity.selectedElement.dispatchEvent(event);
  }

  setBodyModifier() {
    if (this.flickity.selectedElement.classList.contains("has-dark-background")) {
      this.body.classList.add("has-dark-background");
    } else {
      this.body.classList.remove("has-dark-background");
    }
  }
}
